import { IStoreAddresses } from './IStoreAddresses';

export const storeAddresses: IStoreAddresses[] = [
  {
    title: 'Belo Horizonte',
    addresses: [
      {
        name: 'Plk JK Brasília',
        street: 'QNM 34 ÁREA ESPECIAL 1 S/N, LOJA 348, PISO L3',
        number: 459,
        district: 'TAGUATINGA',
        city: 'Brasília',
        state: 'DF',
        zipcode: '7214-545',
        delivery: true,
      },
      {
        name: 'Plk Via Shopping Barreiro',
        street: 'Av. Afonso Vaz de Melo',
        number: 640,
        district: '',
        city: 'Belo Horizonte',
        state: 'MG',
        zipcode: '30640-070',
        delivery: true,
      },
    ],
  },
  {
    title: 'BRASILIA',
    addresses: [
      {
        name: 'Plk JK Brasília',
        street: 'QNM 34 ÁREA ESPECIAL 1 S/N, LOJA 348, PISO L3',
        number: 459,
        district: 'TAGUATINGA',
        city: 'Brasília',
        state: 'DF',
        zipcode: '7214-545',
        delivery: true,
      },
    ],
  },
  {
    title: 'MINAS GERAIS',
    addresses: [
      {
        name: 'Plk ItauPower',
        street: 'Av. General David Sarnoff, loja 33, piso 1',
        number: '',
        district: '',
        city: 'Contagem',
        state: 'MG',
        zipcode: '32210-110',
        delivery: true,
      },
    ],
  },
  {
    title: 'RIO DE JANEIRO',
    addresses: [
      {
        name: 'Shopping Nova Iguaçu',
        street: 'Av. Abílio Augusto Távora',
        number: 1111,
        district: '',
        city: 'Nova Iguaçu',
        state: 'RJ',
        zipcode: '26260-045',
        delivery: true,
      },
      {
        name: 'Shopping Nova America',
        street: 'Av. Pastor Martin Luther King Jr',
        number: 126,
        district: '',
        city: 'Rio de Janeiro',
        state: 'RJ',
        zipcode: '20765-000',
        delivery: true,
      },
      {
        name: 'Shopping Grande Rio',
        street: 'Rua Maria Soares Sendas',
        number: 111,
        district: '',
        city: 'Rio de Janeiro',
        state: 'RJ',
        zipcode: '25575-825',
        delivery: true,
      },
      {
        name: 'Norte Shopping',
        street: 'Av. Dom Hélder Câmara',
        number: 5332,
        district: '',
        city: 'Rio de Janeiro',
        state: 'RJ',
        zipcode: '20771-004',
        delivery: true,
      },
      {
        name: 'Shopping Madureira',
        street: 'Estrada do Portela',
        number: 222,
        district: '',
        city: 'Rio de Janeiro',
        state: 'RJ',
        zipcode: '21351-900',
        delivery: true,
      },
      {
        name: 'Plaza Shopping Niterói',
        street: 'Rua Quinze de Novembro',
        number: 8,
        district: '',
        city: 'Niterói',
        state: 'RJ',
        zipcode: '24020-125',
        delivery: true,
      },
      {
        name: 'Shopping Jacarepagua',
        street: 'Estrada de Jacarepaguá',
        number: 6069,
        district: 'Luc Cob 04 A/B Nível L3',
        city: 'Rio de Janeiro',
        state: 'RJ',
        zipcode: '24020-125',
        delivery: true,
      },
      
      
     
    ],
  },
  {
    
    title: 'SÃO PAULO',
    addresses: [
      {
        name: 'Shopping Praça de Moça',
        street: 'Rua Manoel da Nóbrega',
        number: 712,
        district: '501 - Centro',
        city: 'Diadema',
        state: 'SP',
        zipcode: '09910-720',
        delivery: true,
      },
      {
        name: 'Shopping Metropole SBC',
        street: 'Praça Samuel Sabatini',
        number: 712,
        district: 'Centro',
        city: 'São Bernardo do Campo',
        state: 'SP',
        zipcode: '09750-700',
        delivery: true,
      },
      {
        name: 'São Bernardo Plaza Shopping',
        street: 'Avenida Rotary',
        number: 624,
        district: 'Centro',
        city: 'São Bernardo do Campo',
        state: 'SP',
        zipcode: '09721-000',
        delivery: true,
      },
      {
        name: 'Grand Plaza Shopping',
        street: 'Av. Industrial',
        number: 600,
        district: 'Centro',
        city: 'Santo André',
        state: 'SP',
        zipcode: '09080-510',
        delivery: true,
      },
      {
        name: 'Shopping Diadema',
        street: 'Av. Afonso Monteiro da Cruz',
        number: 1150,
        district: 'Serraria',
        city: 'Diadema',
        state: 'SP',
        zipcode: '09980-550',
        delivery: true,
      },
      {
        name: 'Shopping Maua',
        street: 'Av. Gov. Mario Covas Júnior',
        number: 1,
        district: 'Centro',
        city: 'Maua',
        state: 'SP',
        zipcode: '09390-040',
        delivery: true,
      },
      {
        name: 'Shopping La Plage',
        street: 'Av. Mal. Deodoro da Fonseca',
        number: 885,
        district: '',
        city: 'Guarujá',
        state: 'SP',
        zipcode: '11410-221',
        delivery: true,
      },
      {
        name: 'Central Plaza Shopping',
        street: 'Av. Dr. Francisco Mesquita',
        number: 1000,
        district: 'Jardim Ibitirama',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '03153-001',
        delivery: true,
      },
      {
        name: 'Shopping Cidade São Paulo',
        street: 'Av. Paulista',
        number: 1230,
        district: 'Bela Vista',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '01310-100',
        delivery: false,
      },
      {
        name: 'Shopping Light',
        street: 'Rua Cel. Xavier de Toledo',
        number: 23,
        district: 'República',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '01048-100',
        delivery: false,
      },
      {
        name: 'Shopping Center 3',
        street: 'Av. Paulista',
        number: 2064,
        district: 'Cerqueira César',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '01304-001',
        delivery: false,
      },
      {
        name: 'Shopping Boa Vista',
        street: 'Rua Borba Gato',
        number: 59,
        district: 'Santo Amaro',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '04747-030',
        delivery: true,
      },
      {
        name: 'Shopping Eldorado',
        street: 'Av. Rebouças',
        number: 3970,
        district: 'Pinheiros',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '05402-600',
        delivery: false,
      },
      {
        name: 'Shopping Vila Olimpia',
        street: 'Rua Olimpíada',
        number: 360,
        district: 'Vila Olímpia',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '04551-000',
        delivery: true,
      },
      {
        name: 'Shopping Parque Dom Pedro',
        street: 'Av. Guilherme Campos',
        number: 500,
        district: 'Jardim Santa Genebra',
        city: 'Campinas',
        state: 'SP',
        zipcode: '13087-901',
        delivery: true,
      },
      {
        name: 'Shopping Parque das Bandeiras',
        street: 'Av. John Boyd Dunlop',
        number: 3900,
        district: 'Jardim Ipaussurama',
        city: 'Campinas',
        state: 'SP',
        zipcode: '13059-590',
        delivery: true,
      },
      {
        name: 'Campinas Shopping',
        street: 'Rua Jacy Teixeira de Camargo',
        number: 940,
        district: 'Jardim do Lago',
        city: 'Campinas',
        state: 'SP',
        zipcode: '13050-913',
        delivery: true,
      },
      {
        name: 'Shopping Center Limeira',
        street: 'Av. Carlos Kuntz Busch',
        number: 800,
        district: 'Parque Egisto Ragazzo',
        city: 'Limeira',
        state: 'SP',
        zipcode: '13485-346',
        delivery: true,
      },
      {
        name: 'Shopping Mogi Guaçu',
        street: 'Rua Francisco Franco de Godoy Bueno',
        number: 801,
        district: '',
        city: 'Mogi Guaçu',
        state: 'SP',
        zipcode: '13845-180',
        delivery: true,
      },
      {
        name: 'Shopping Park City Sumaré',
        street: 'Av. Rebouças',
        number: 3400,
        district: '',
        city: 'Sumaré',
        state: 'SP',
        zipcode: '13170-023',
        delivery: true,
      },
      {
        name: 'Maxi Shopping Jundiaí',
        street: 'Av. Antônio Frederico Ozanan',
        number: 6000,
        district: '',
        city: 'Jundiaí',
        state: 'SP',
        zipcode: '13215-275',
        delivery: true,
      },
      {
        name: 'Shopping Piracicaba',
        street: 'Av. Limeira',
        number: 722,
        district: 'Areião',
        city: 'Piracicaba',
        state: 'SP',
        zipcode: '13414-016',
        delivery: true,
      },
      {
        name: 'Ghost Kitchen Popeyes - Não é shopping',
        street: 'Rua Matias Aires',
        number: 87,
        district: 'Bela Vista',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '01309-020',
        delivery: true,
      },
      {
        name: 'Shopping Metro Itaquera',
        street: 'Av. José Pinheiro Borges, S/N',
        number: null,
        district: 'Itaquera',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '08220-900',
        delivery: true,
      },
      {
        name: 'Shopping Metro Tatuapé',
        street: 'Rua Melo Freire, S/N',
        number: null,
        district: 'Tatuapé',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '03314-030',
        delivery: true,
      },
      {
        name: 'Shopping Suzano',
        street: 'Rua Sete de Setembro',
        number: 555,
        district: 'Jardim Nena',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '08674-210',
        delivery: true,
      },
      {
        name: 'Shopping Bonsucesso',
        street: 'Av. Juscelino Kubitschek de Oliveira',
        number: 5308,
        district: '',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '07243-504',
        delivery: true,
      },
      {
        name: 'Shopping Metro Boulevard Tatuape',
        street: 'Rua Gonçalves Crespo',
        number: 78,
        district: '',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '03066-030',
        delivery: true,
      },
      {
        name: 'Shopping Aricanduva',
        street: 'Avenida Aricanduva',
        number: 5555,
        district: 'Aricanduva',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '03572-000',
        delivery: true,
      },
      {
        name: 'Shopping Center Penha',
        street: 'Rua Dr. João Ribeiro',
        number: 304,
        district: 'Penha de França',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '03634-000',
        delivery: true,
      },
      {
        name: 'Shopping Internacional de Guarulhos',
        street: 'Rod. Presidente Dutra, Saída 225, S/N',
        number: null,
        district: 'Itapejica',
        city: 'Guarulhos',
        state: 'SP',
        zipcode: '07034-911',
        delivery: true,
      },
      {
        name: 'Cantareira Norte Shopping',
        street: 'Av. Raimundo Pereira de Magalhães',
        number: 11001,
        district: 'Jardim Pirituba',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '02984-035',
        delivery: true,
      },
      {
        name: 'Tiete Plaza Shopping',
        street: 'Av. Raimundo Pereira de Magalhães',
        number: 1465,
        district: 'Jardim Iris',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '05145-000',
        delivery: true,
      },
      {
        name: 'Shopping D',
        street: 'Av. Cruzeiro do Sul',
        number: 1100,
        district: 'Canindé',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '03033-020',
        delivery: true,
      },
      {
        name: 'Santana Parque Shopping',
        street: 'Rua Conselheiro Moreira de Barros',
        number: 2780,
        district: 'Santana',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '02430-001',
        delivery: true,
      },
      {
        name: 'Shopping Metro Tucuruvi',
        street: 'Rua Paranabi',
        number: '218-224',
        district: 'Tucuruvi',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '02307-120',
        delivery: true,
      },
      {
        name: 'Shopping Center Norte',
        street: 'Av. Casalbuono',
        number: 120,
        district: 'Vila Guilherme',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '02049-900',
        delivery: true,
      },
      {
        name: 'Shopping West Plaza',
        street: 'Av. Francisco Matarazzo, S/N',
        number: null,
        district: 'Água Branca',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '05003-020',
        delivery: false,
      },
      {
        name: 'Shopping Barueri',
        street: 'Rua Gen. de Divisão Pedro Rodrigues da Silva',
        number: 400,
        district: 'Nova Aldeinha',
        city: 'Barueri',
        state: 'SP',
        zipcode: '06440-180',
        delivery: true,
      },
      {
        name: 'Shopping Taboão',
        street: 'Rodovia Regis Bittencourt',
        number: 2643,
        district: '',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '06768-200',
        delivery: true,
      },
      {
        name: 'Super Shopping Osasco',
        street: 'Av. dos Autonomistas',
        number: 1828,
        district: 'Industrial Autonomistas',
        city: 'Osasco',
        state: 'SP',
        zipcode: '06020-010',
        delivery: true,
      },
      {
        name: 'Shopping SP Market',
        street: 'Av. das Nações Unidas',
        number: 22540,
        district: 'Jurubatuba',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '04795-000',
        delivery: true,
      },
      {
        name: 'Shopping Mais',
        street: 'Rua Amador Bueno',
        number: 229,
        district: 'Santo Amaro',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '04752-005',
        delivery: true,
      },
      {
        name: 'Shopping Fiesta',
        street: 'Av. Guarapiranga',
        number: 752,
        district: 'Vila Socorro',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '04762-001',
        delivery: true,
      },
      {
        name: 'Anhanguera Parque Shopping',
        street: 'Rua Jean Anastace Kovelis',
        number: 123,
        district: 'Ipês (Polvilho)',
        city: 'Cajamar',
        state: 'SP',
        zipcode: '07791-803',
        delivery: true,
      },
      {
        name: 'Shopping Pátio Cianê',
        street: 'Av. Doutor Afonso Vergueiro',
        number: 823,
        district: 'Loja 210-1 Pavmt O2 Bloco I',
        city: 'Sorocaba',
        state: 'SP',
        zipcode: '18035-370',
        delivery: true,
      },
      {
        name: 'Plk Campo Limpo',
        street: 'Estrada do Campo Limpo',
        number: 459,
        district: 'Vila Prel',
        city: 'São Paulo',
        state: 'SP',
        zipcode: '05777-970',
        delivery: true,
      },
    ],
  },
  
 
  
];
